import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Leaf } from "lucide-react";
import { COMPANY, CERTIFICATIONS } from "@/lib/company";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-brand-green-dark text-white/90">
      {/* Certification marquee strip */}
      <div className="border-b border-white/10 bg-brand-green">
        <div className="py-4 overflow-hidden">
          <div className="marquee-track">
            {[...CERTIFICATIONS, ...CERTIFICATIONS].map((c, i) => (
              <span
                key={i}
                className="mx-6 text-xs sm:text-sm uppercase tracking-wider text-brand-gold font-semibold whitespace-nowrap flex items-center gap-2"
              >
                <span className="w-1.5 h-1.5 bg-brand-gold rounded-full inline-block" />
                {c}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-14">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Company */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-md bg-brand-gold flex items-center justify-center">
                <Leaf className="w-5 h-5 text-brand-green-dark" strokeWidth={2.2} />
              </div>
              <div className="font-display font-bold text-lg">Aad Labs</div>
            </div>
            <p className="text-sm text-white/70 leading-relaxed">
              {COMPANY.name}. A professional sourcing & export trading company connecting India's finest GMP-certified manufacturers to global buyers.
            </p>
          </div>

          {/* Explore */}
          <div>
            <h4 className="font-display font-bold text-white mb-4 text-sm uppercase tracking-widest">Explore</h4>
            <ul className="space-y-2 text-sm">
              <li><Link data-testid="footer-link-home" to="/" className="hover:text-brand-gold transition-colors">Home</Link></li>
              <li><Link data-testid="footer-link-about" to="/about" className="hover:text-brand-gold transition-colors">About Us</Link></li>
              <li><Link data-testid="footer-link-botanical" to="/products/botanical-extracts" className="hover:text-brand-gold transition-colors">Botanical Extracts</Link></li>
              <li><Link data-testid="footer-link-spices" to="/products/spices-seeds-grains" className="hover:text-brand-gold transition-colors">Spices, Seeds & Grains</Link></li>
              <li><Link data-testid="footer-link-coffee" to="/products/coffee-beans" className="hover:text-brand-gold transition-colors">Coffee Beans</Link></li>
              <li><Link data-testid="footer-link-packaging" to="/products/eco-packaging" className="hover:text-brand-gold transition-colors">Eco Packaging</Link></li>
              <li><Link data-testid="footer-link-quality" to="/quality" className="hover:text-brand-gold transition-colors">Quality Assurance</Link></li>
              <li><Link data-testid="footer-link-certifications" to="/certifications" className="hover:text-brand-gold transition-colors">Certifications</Link></li>
              <li><Link data-testid="footer-link-contact" to="/contact" className="hover:text-brand-gold transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display font-bold text-white mb-4 text-sm uppercase tracking-widest">Contact</h4>
            <ul className="space-y-3 text-sm text-white/80">
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 text-brand-gold shrink-0" />
                <span>{COMPANY.address}</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-brand-gold" />
                <a data-testid="footer-email" href={`mailto:${COMPANY.email}`} className="hover:text-brand-gold transition-colors">{COMPANY.email}</a>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-brand-gold" />
                <a data-testid="footer-phone" href={`tel:${COMPANY.phoneRaw}`} className="hover:text-brand-gold transition-colors">{COMPANY.phone}</a>
              </li>
            </ul>
          </div>

          {/* Compliance */}
          <div>
            <h4 className="font-display font-bold text-white mb-4 text-sm uppercase tracking-widest">Registration</h4>
            <ul className="space-y-2 text-sm text-white/80">
              <li><span className="text-brand-gold font-semibold">IEC:</span> {COMPANY.iec}</li>
              <li><span className="text-brand-gold font-semibold">GSTIN:</span> {COMPANY.gstin}</li>
              <li><span className="text-brand-gold font-semibold">FSSAI:</span> {COMPANY.fssai}</li>
              <li><span className="text-brand-gold font-semibold">PAN:</span> {COMPANY.pan}</li>
              <li><span className="text-brand-gold font-semibold">Director:</span> {COMPANY.director}</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-white/60">
          <div>© 2026 {COMPANY.name}. All Rights Reserved.</div>
          <div className="max-w-2xl md:text-right">
            <strong className="text-white/80">Disclaimer:</strong> Aad Labs is a trading and export company. We work with reputed third-party manufacturers to source premium products for global markets.
          </div>
        </div>
      </div>
    </footer>
  );
}
